import ImageWithPlaceholder from '../../ImageWithPlaceholder.tsx';
import { isPropsBet } from '../../../helpers/functions.tsx';

export const DEFAULT_PROPS_LOGO = '/images/props-logo.svg';
export const OVER_MARK_LOGO = '/images/over-mark.svg';
export const UNDER_MARK_LOGO = '/images/under-mark.svg';

export function logoForSelectionLine(selectionLine?: string | null, fallback = ''): string {
    const line = String(selectionLine ?? '').toLowerCase();
    if (line === 'over' || line.startsWith('over')) return OVER_MARK_LOGO;
    if (line === 'under' || line.startsWith('under')) return UNDER_MARK_LOGO;
    return fallback;
}

type BetLogoBet = {
    logo?: string;
    gameType?: string;
    odd?: {
        selection_line?: string | null;
        team_id?: string | number | null;
        player_id?: string | number | null;
        market_id?: string | number | null;
    };
};

function getOverUnderLine(bet?: BetLogoBet | null): 'over' | 'under' | null {
    const line = String(bet?.odd?.selection_line ?? '').toLowerCase();
    if (line === 'over' || line.startsWith('over')) return 'over';
    if (line === 'under' || line.startsWith('under')) return 'under';
    return null;
}

function placeholderFor(className: string) {
    if (className.includes('sport-logos-pending-player')) return 'placeholder-logos-pending-player';
    if (className.includes('sport-logos-pending')) return 'placeholder-logos-pending';
    if (className.includes('sport-logos-modal')) return 'placeholder-logos-modal';
    return 'placeholder-logos-team';
}

function BetLogo({
    bet,
    className = 'sport-logos',
    alt = '',
}: {
    bet?: BetLogoBet | null;
    className?: string;
    alt?: string;
}) {
    const overUnder = getOverUnderLine(bet);
    const requested = bet?.logo?.trim() || '';

    if (!bet) return null;

    if (isPropsBet(bet)) {
        return <img src={DEFAULT_PROPS_LOGO} className={className} alt={alt} />;
    }

    if (overUnder === 'over') {
        return <img src={OVER_MARK_LOGO} className={className} alt={alt} />;
    }
    if (overUnder === 'under') {
        return <img src={UNDER_MARK_LOGO} className={className} alt={alt} />;
    }

    return (
        <ImageWithPlaceholder
            src={requested}
            className={className}
            placeholderClassName={placeholderFor(className)}
            fallbackSrc={DEFAULT_PROPS_LOGO}
            alt={alt}
        />
    );
}

export default BetLogo;
